export default "__VITE_ASSET__r_KShfSV__"